module.exports = __webpack_public_path__ + "img/默认图.a7834d37.png";